import { useCallback, useMemo } from 'react';
import { makeVar, useReactiveVar } from '@apollo/client';
import { GqlVideoFragment } from '../apollo/generated/graphql';
import { useChannelVideos } from './useChannelVideos';

const selectedVideoVar = makeVar<GqlVideoFragment | undefined>(undefined);

export function useSelectedVideo() {
  const { videos } = useChannelVideos();
  const selectedVideoFromVar = useReactiveVar(selectedVideoVar);

  // using useMemo for SSR
  const selectedVideo = useMemo(() => {
    if (!selectedVideoFromVar) {
      const video = videos[0];
      selectedVideoVar(video);
      return video;
    }

    return selectedVideoFromVar;
  }, [videos, selectedVideoFromVar]);

  const selectVideo = useCallback((video: GqlVideoFragment) => {
    selectedVideoVar(video);
  }, []);

  return {
    selectedVideo,
    selectVideo,
  };
}
